// react components
import { useState, useEffect } from "react";
// react-router-dom components

// mui components
// import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

// mui-icons components

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// components
// import APPCharts from "../charts/APPCharts";
import AdditionalProductPerformanceTable from "./AdditionalProductPerformanceTable";

//redux
import { useSelector, useDispatch } from "react-redux";
import { loadTop2BoxToggleState } from "store/features/respondentDashboardSlice";
import AddProAnalysisChart from "../charts/AddProAnalysisChart";

function AdditionalProductPerformanceLayout({ minHeight = 360, data = [], filterData = {} }) {
    const dispatch = useDispatch();

    const [isTableShown, setIsTableShown] = useState(true);
    const [column2, setColumn2] = useState([]);
    const top2BoxToggle = useSelector((state) => state.respondentDashboardStore.top2BoxToggle);
    const handleToggleChange = () => {
        setIsTableShown(!isTableShown);
    };

    useEffect(() => {
        const filterMap = filterData?.mapping || {};
        const bv = Object.keys(filterMap);
        const arr = bv.map((key) => {
            return {
                displayLabel: filterMap?.[key] || "",
                backendVariable: key,
            };
        });
        setColumn2(arr);
    }, [filterData]);

    const handleTop2BoxToggleChange = () => {
        // clearResult();
        dispatch(loadTop2BoxToggleState(!top2BoxToggle));
    };

    return (
        <div
            style={{
                minHeight: `${minHeight}px`,
                padding: "0px 16px",
            }}
        >
            <div className="clearfix">
                <div
                    className="clearfix"
                    style={{
                        color: "#005eef",
                        display: "inline-block",
                        float: "left",
                    }}
                >
                    <div>
                        <div
                            className=" d-flex"
                            style={{ alignItems: "center" }}
                        >
                            <Typography
                                className="text-upper-case color-blue"
                                sx={{ fontSize: "12px", fontWeight: isTableShown ? "700" : "400", marginRight: "5px" }}
                            >
                                Table
                            </Typography>
                            <Switch
                                size="small"
                                checked={!isTableShown}
                                color="default"
                                onChange={handleToggleChange}
                            />
                            <Typography
                                className="text-upper-case color-blue"
                                sx={{ fontSize: "12px", fontWeight: !isTableShown ? "700" : "400", marginLeft: "5px" }}
                            >
                                Chart
                            </Typography>
                        </div>
                        <div
                            className="d-flex"
                            style={{ alignItems: "center" }}
                        >
                            <Typography
                                className="text-upper-case color-blue"
                                sx={{ fontSize: "12px", fontWeight: top2BoxToggle ? "700" : "400", marginRight: "5px" }}
                            >
                                Top-2-Box
                            </Typography>
                            <Switch
                                size="small"
                                checked={!top2BoxToggle}
                                color="default"
                                onChange={handleTop2BoxToggleChange}
                            />
                            <Typography
                                className="text-upper-case color-blue"
                                sx={{ fontSize: "12px", fontWeight: !top2BoxToggle ? "700" : "400", marginLeft: "5px" }}
                            >
                                Mean
                            </Typography>
                        </div>
                    </div>
                </div>
            </div>

            <div
                style={{
                    marginBottom: "10px",
                    marginTop: "20px",
                }}
            >
                {isTableShown ? (
                    <AdditionalProductPerformanceTable
                        analysisData={data}
                        minHeight={minHeight}
                        isTop2BoxValuesShown={top2BoxToggle}
                        column2={column2}
                    />
                ) : (
                    <AddProAnalysisChart
                        productsSecondaryData={data}
                        column2={column2}
                        chartType={top2BoxToggle ? "bar" : "line"}
                        isTop2BoxValuesShown={top2BoxToggle}
                    />
                )}
            </div>
        </div>
    );
}

// Typechecking props for the GraphLayout
AdditionalProductPerformanceLayout.propTypes = {
    minHeight: PropTypes.number,
    data: PropTypes.array,
    filterData: PropTypes.object,
    // fetchModalState: PropTypes.func,
};

export default AdditionalProductPerformanceLayout;
